import React, { Fragment } from 'react';
import { ObjectFieldTemplateProps } from '@rjsf/core';
import {
  getUiOptions
  //@ts-ignore
} from '@rjsf/core/lib/utils';
import { useSchemaTranslation } from '../../../useSchemaTranslation';
import { Segment } from 'semantic-ui-react';

const ObjectFieldTemplate = (props: ObjectFieldTemplateProps) => {
  const {
    DescriptionField,
    description,
    TitleField,
    title,
    properties,
    required,
    uiSchema,
    idSchema,
    formContext = {},
  } = props;

  const { objectFieldTemplates = {}, propertyWrapper: defautlPropertyWrapper } = formContext
  const { propertyWrapperProps = {}, propertyWrapper, wrapperClassName = "", objectTemplate = "" } = getUiOptions(uiSchema) || {}
  const { t } = useSchemaTranslation();

  const isRoot = idSchema.$id === "root"

  const PropertyWrapper = propertyWrapper === "segment" ? Segment : propertyWrapper ? propertyWrapper : defautlPropertyWrapper || isRoot ? "div" : "div";

  const CustomTemplate = objectTemplate && typeof objectTemplate === "string" && objectFieldTemplates[objectTemplate]
  if (CustomTemplate) {
    //@ts-ignore
    return <CustomTemplate className="ObjectFieldTemplate-container"  {...props} />
  };

  return (
    <div className={"ObjectFieldTemplate-wrapper " + wrapperClassName}>
      {(uiSchema['ui:title'] || title) && (
        <TitleField
          id={`${idSchema.$id}-title`}
          title={t(title)}
          required={required}
          //@ts-ignore
          headerProps={{
            className: "ObjectFieldTemplate-title",
            ...(uiSchema["ui:header"] || {})
          }}
        />
      )}
      {description && (
        <DescriptionField
          id={`${idSchema.$id}-description`}
          description={t(description)}
        />
      )}
      <PropertyWrapper className="ObjectFieldTemplate-properties" {...propertyWrapperProps}>
        {properties.map((element: any, index) => (
          <Fragment key={index}>
            {element.content}
          </Fragment>
        ))}
      </PropertyWrapper>
    </div>
  );
};

export default ObjectFieldTemplate;
